import * as React from 'react'

import { ModalContext } from './ModalContext'

export function useModal() {
  const modalContext = React.useContext(ModalContext)

  React.useEffect(() => {
    return () => {
      modalContext.hideModal()
    }
  }, [])

  return modalContext
}
